import { render, staticRenderFns } from "./MsgElementCommonQuestions.vue?vue&type=template&id=5969156e&scoped=true"
import script from "./MsgElementCommonQuestions.vue?vue&type=script&lang=js"
export * from "./MsgElementCommonQuestions.vue?vue&type=script&lang=js"
import style0 from "./MsgElementCommonQuestions.vue?vue&type=style&index=0&id=5969156e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5969156e",
  null
  
)

export default component.exports